export default {
  title: {
    id: 'bo_seller.opportunities.inventory.title',
    defaultMessage: 'Inventory opportunities',
  },
  subtitle: {
    id: 'bo_seller.opportunities.inventory.subtitle',
    defaultMessage:
      'Sell more by diversifying your stock with these high-demand products.',
  },
  inventoryOpportunitiesCount: {
    id: 'bo_seller.opportunities.inventory.inventoryOpportunitiesCount',
    defaultMessage: `{count, plural,
      =0 {0 opportunity}
      one {# opportunity}
      other {# opportunities}
    }`,
  },
  viewListing: {
    id: 'bo_seller.opportunities.inventory.view_listing',
    defaultMessage: 'View listing',
  },
  createListing: {
    id: 'bo_seller.opportunities.inventory.create_listing',
    defaultMessage: 'Create listing',
  },
  loadingText: {
    id: 'bo_seller.opportunities.inventory.loadingText',
    defaultMessage: 'Loading inventory opportunities...',
  },
  columnDemandRanking: {
    id: 'bo_seller.opportunities.inventory.column.demand_ranking',
    defaultMessage: 'Demand ranking (last 30 days)',
  },
  columnProduct: {
    id: 'bo_seller.opportunities.inventory.column.product',
    defaultMessage: 'Product',
  },
  columnBrand: {
    id: 'bo_seller.opportunities.inventory.column.brand',
    defaultMessage: 'Brand',
  },
  columnGrade: {
    id: 'bo_seller.opportunities.inventory.column.grade',
    defaultMessage: 'Grade',
  },
  columnCategory: {
    id: 'bo_seller.opportunities.inventory.column.category',
    defaultMessage: 'Category',
  },
  columnListed: {
    id: 'bo_seller.opportunities.inventory.column.listed',
    defaultMessage: 'Listed',
  },
  columnQuantity: {
    id: 'bo_seller.opportunities.inventory.column.quantity',
    defaultMessage: 'Quantity',
  },
  columnQuantitySold: {
    id: 'bo_seller.opportunities.inventory.column.quantity_sold',
    defaultMessage: 'Quantity sold in the past',
  },
  columnPriceOnPlatform: {
    id: 'bo_seller.opportunities.inventory.column.price_on_platform',
    defaultMessage: 'Price on platform (last 30 days)',
  },
  columnEstimatedDemand: {
    id: 'bo_seller.opportunities.inventory.column.estimated_demand',
    defaultMessage: 'Estimated demand',
  },
  columnCompetition: {
    id: 'bo_seller.opportunities.inventory.column.competition',
    defaultMessage: 'Competition',
  },
  columnActions: {
    id: 'bo_seller.opportunities.inventory.column.actions',
    defaultMessage: 'Actions',
  },
}
